export default "__VITE_ASSET__Cf$zoGw3__"